import { render } from "./VersionDialog.vue?vue&type=template&id=db8e94e2&scoped=true"
import script from "./VersionDialog.vue?vue&type=script&lang=js"
export * from "./VersionDialog.vue?vue&type=script&lang=js"

import "./VersionDialog.vue?vue&type=style&index=0&id=db8e94e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8e94e2"]])

export default __exports__